import axios from 'axios';

export const searchContent = (input, searchClass) => axios.get('/v1/public/cells/search', { params: { input, searchClass } });
export const searchKeywords = (keywords, sentence, skip, limit) => axios.get('/v1/public/cells/search/keywords', { params: { keywords, sentence, skip, limit } });
export const getCellsByReference = (referenceTitle, referenceAuthor) => axios.get('/v1/public/cells/by-reference', { params: { referenceTitle, referenceAuthor } });
export const showCells = (cellIds) => axios.post('/v1/public/show', { cellIds });
export const appendCells = (cellIds) => axios.post('/v1/public/append', { cellIds });
export const getCellInfo = (ids) => axios.get('/v1/public/celllist', { params: { ids } });
export const getProducerList = (page) => axios.get('/v1/public/producers', { params: { page } });
export const getUserDetailInfo = (id) => axios.get(`/v1/public/users/${id}`);
export const getUserProfiles = (userId) => axios.get(`/v1/public/users/${userId}/profiles`);
export const getFAQList = () => axios.get('/v1/public/faq');
export const getCollection = (id) => axios.get(`/v1/public/collections/${id}`);
export const increaseCollectionViewCount = (collectionId, language) => axios.post(`/v1/public/collections/${collectionId}/${language}/view-count/increase`);

export const getRelatedCell = (cellId, limit) => axios.get('/v1/public/cells/related', { params: { cellId, limit } });
export const getProducerCollection = (id, skip, limit, type, language) => axios.get(`/v1/public/users/${id}/collections`, { params: { skip, limit, type, language } });
export const getProducerCell = (id, skip, limit) => axios.get(`/v1/public/users/${id}/cells`, { params: { skip, limit } });

export const getCollectionsByCategory = (category, skip, limit, skipIds) => axios.post(`/v1/public/collections/by-category/${category}`, { skip, limit, skipIds });

export const getCollectionsByCategoryAtOnce = () => axios.post('/v1/public/collections/by-category/at-once');

export const increaseCellViewCount = (cellId, language) => axios.post(`/v1/public/cells/${cellId}/${language}/view-count/increase`);

// 특정 컬렉션에 관련된 컬렉션 조회
export const getRelatedCollection = (collectionId, limit) => axios.get(`/v1/public/collections/${collectionId}/related-collections`, { params: { limit } });

// 특정 지식셀이 포함되거나 관련된 컬렉션 조회
export const getContainedCollection = (id) => axios.get(`/v1/public/cells/${id}/related-collections`);

// 사용자 챗 목록 조회
export const getUserChatList = (userId) => axios.get(`/v1/public/users/${userId}/messages`);

// 독자 응원글 조회
export const getUserCheersList = (userId) => axios.get(`/v1/public/users/${userId}/cheers`);

// 사용자가 최근 본 지식셀 목록 조회
export const getUserVeiwedCell = (user, skip, limit) => axios.get('/v1/public/cells/viewed', { params: { user, skip, limit } });

// 사용자가 최근 좋아요한 컬렉션 목록 조회
export const getUserLikeCollection = (userId, skip, limit) => axios.get(`/v1/public/collections/liked-by/${userId}`, { params: { skip, limit } });

// 사용자가 최근 좋아요한 모임방 목록 조회
export const getUserLikeKnowledgeTalk = (user, skip, limit) => axios.get('/v1/public/togethers/like', { params: { user, skip, limit } });

// 컬렉션 검색
export const searchCollections = (input, searchClass) => axios.post('/v1/public/collections/search', { input, searchClass });

// 랜덤한 하나의 지식셀 조회
export const getRandomCell = () => axios.get('/v1/public/cells/random');

// 키워드 검색시 오타교정
export const editSearchKeywords = (keywords) => axios.post('/v1/public/collections/generate/edit', { keywords });

// 사용자 랭킹 조회 (keywordType 옵션 추가, isSClass 생략 가능)
export const getUserRanking = ({ keyword, keywordType, skip, limit, language, isSClass } = {}) => axios.get('/v1/public/users/ranking', {
  params: {
    skip,
    limit,
    ...(keyword ? { keyword } : {}),
    ...(keywordType ? { keywordType } : {}),
    ...(language ? { language } : {}),
    ...(typeof isSClass === 'boolean' ? { isSClass } : {}),
  },
});

// Gather 정보 조회
export const getGatherInfo = () => axios.get('/v1/public/togethers/gather-rooms');

// 유저 지식 여행기 조회
export const getUserJisikTripInfo = (id) => axios.get(`/v1/public/users/${id}/activity-summary`);

// 공개 메모 조회
export const getPublicMemoList = (skip, limit) => axios.get('/v1/public/memos', { params: { skip, limit } });

// 공개 메모 조회(특정유저)
export const getPublicMemoListById = (userId, collectionId, cellId) => axios.get('/v1/public/memos', { params: { userId, collectionId, cellId } });

// 공개 메모 조회(타입별)
export const getPublicMemoByType = (userId, type, skip, limt) => axios.get('/v1/public/memos', { params: { userId, type, skip, limt } });

// 공개 메모 키워드 조회
export const getPublicMemoKeywordList = (userId) => axios.get('/v1/public/memos/keywords', { params: { userId } });

// 메모 상세 조회
export const getMemoDetail = (id) => axios.get(`/v1/public/memos/${id}`);

// 메모 댓글 조회
export const getMemoChatList = (memoId) => axios.get(`/v1/public/memos/${memoId}/messages`);

// 문장 핵심어 추출
export const getSummary = (text) => axios.get('/v1/public/cells/summary', { params: { text } });

// 배너 목록 조회
export const getBannerList = () => axios.get('/v1/public/questions');

// 배너 상세 조회
export const getBannerDetail = (id) => axios.get(`/v1/public/questions/${id}`);

// 새로 나온 미니북 조회 (지식탐구독자가 7일 이내에 작성한 미니북 목록)
export const getNewCollections = (skip, limit) => axios.get('v1/public/collections/new', { params: { withoutTimeLimit: true, skip, limit } });

// S-CLASS 교수가 만든 미니북 조회 (S-CLASS 교수가 작성한 미니북 목록)
export const getCollectionsBySClass = (skip, limit) => axios.get('v1/public/collections/by-s-class', { params: { skip, limit } });

// Best seller 미니북 조회 @cityandinfo 계정 미니북
export const getBestCollections = (skip, limit, seed) => axios.get('v1/public/collections/best-seller', { params: { skip, limit, seed } });

// AI 와 함께, 오늘의 미니북 조회
// 프로듀서가 생성하고, AI 가 만든 페이지를 포함하는 미니북을 랜덤으로 조회.
// 단, 24시간 내에 새로 만들어진 미니북이 있다면 리스트 제일 앞에 포함됨.
export const getTodayCollections = () => axios.get('v1/public/today-collections');

// 투게더 공지사항 조회
export const getTogetherNoticeList = (togetherId) => axios.get(`/v1/public/togethers/${togetherId}/notices`);

// 미니북 조회 (언어별)
export const getCollectionByLanguage = (id, language) => axios.get(`/v1/public/collections/${id}?language=${language}`);

// 페이지 조회 (언어별)
export const getCellByLanguage = (id, language) => axios.get(`/v1/public/cells/${id}?language=${language}`);

// 사용자 랭킹 조회
export const getUserRankingForJisikTrip = (userId) => axios.get(`/v1/public/users/${userId}/ranking`);

// 오픈 미니북 저자 목록
export const getOwnerList = (collectionId) => axios.get(`/v1/public/collections/${collectionId}/owners`);

// 이벤트 검색
export const searchEvents = (keyword) => axios.get('/v1/public/events/search', { params: { keyword } });

// 미니북 조회(사용자 핸들)
export const getCollectionByHandle = (handle, localId) => axios.get(`/v1/public/collections/resolve/${handle}/${localId}`);

// 페이지 조회(사용자 핸들)
export const getCellByHandle = (handle, localId) => axios.get(`/v1/public/cells/resolve/${handle}/${localId}`);

// 이벤트 공간 조회(사용자 핸들)
export const getEventSpaceByHandle = (handle, localId) => axios.get(`/v1/public/togethers/resolve/${handle}/${localId}`);

// 이벤트 조회(사용자 핸들)
export const getEventByHandle = (handle, togetherLocalId, eventLocalId) => axios.get(`/v1/public/events/resolve/${handle}/${togetherLocalId}/${eventLocalId}`);

// 특정 사용자를 응원하는 사람 조회
export const getCheeredByUserList = (userId) => axios.get(`/v1/public/users/${userId}/cheered-by`);

// 미니북 후원 메시지 조회
export const getSponsorMessages = (collectionId) => axios.get(`/v1/public/collections/${collectionId}/sponsor-messages`);

// 비디오 링크 목록 조회
export const getVideoLinksByUser = (userId, skip = 0, limit = 10) => axios.get(`/v1/public/users/${userId}/video-links`, {
  params: { skip, limit },
});

// 소셜 링크 목록 조회
export const getSocialLinksByUser = (userId, skip = 0, limit = 10) => axios.get(`/v1/public/users/${userId}/social-links`, {
  params: { skip, limit },
});

// 메모 사진 목록 조회
export const getMemoPhotosByUser = (userId, skip = 0, limit = 10) => axios.get(`/v1/public/users/${userId}/memo-photos`, {
  params: { skip, limit },
});

// 홈 페이지 타임라인 조회
export const getTimelineData = (skip, limit) => axios.get('/v1/public/timeline', {
  params: { eventFirst: true, skip, limit },
});

// 최신 이벤트 조회
export const getLatestEvent = () => axios.get('/v1/public/events');

// 강의 가격 조회
export const getLecturePrices = (userId) => axios.get(`/v1/public/users/${userId}/lecture-prices`);

// 강의 공지사항 조회
export const getLectureNotice = (userId) => axios.get(`/v1/public/users/${userId}/lecture-notice`);

// 녹화 강의 목록 조회
export const getRecordedLectures = (page = 1, limit = 20) => axios.get('/v1/public/recorded-lectures', {
  params: { page, limit },
});

// 녹화 강의 단건 조회
export const getRecordedLectureDetail = (id) => axios.get(`/v1/public/recorded-lectures/${id}`);

// 사용자 프로필 조회(핸들)
export const getUserProfileByHandle = (handle) => axios.get(`/v1/public/users/resolve/${handle}`);

// 기관 정보 조회
export const getOrganizationInfo = (key) => axios.get(`/v1/public/organizations/${key}`);

// 기관 목록 조회
export const getOrganizations = () => axios.get('/v1/public/organizations');

// 카테고리별 사용자 조회
export const getUsersByCategory = (category, skip = 0, limit = 10, seed = '') => axios.get(`/v1/public/users/by-category/${category}`, { params: { skip, limit, seed } });

// 홈페이지 인터뷰 랜덤 3개 조회
export const getHomepageInterviews = () => axios.get('/v1/public/homepage-interviews');
